import React from 'react';
import Image from 'next/image';
import Link from 'next/link';

type Props = {
    name: string;
    data: string;
    path: any;
    alt: string;
    width: number;
    height: number;
    post: string;
    link: any;
    testimonialvideo: any;
    handleClick: any;
};
const TestimonialsCarouselItem: React.FC<Props> = ({
    name,
    post,
    data,
    path,
    width,
    height,
    testimonialvideo,
    handleClick,
}) => {
    return (
        <div className="lg:mx-4 md:mx-4 mx-0">
            <Link href={'#'} onClick={() => handleClick(testimonialvideo)} scroll={false}>
                <div className="card h-full rounded-10 case-study-slider dark:bg-[#3C456133] dark:border-[#ffffff33] dark:border dark:border-solid testimonail-slider-card">
                    <div className="card-body flex justify-between flex-wrap gap-3 md:gap-0 lg:gap-0">
                        <div className="card-description flex flex-col justify-between lg:w-3/6 md:w-3/6 gap-0 md:gap-0 lg:gap-2 xl:gap-0">
                            <div className="pr-5">
                                <p className="card-title mb-2.5 fs-lg fw-700 text-textcolor testimonail-slider-text pb-2.5">
                                    {name}
                                </p>
                                <p className="card-text card-text-description fs-md fw-400 mb-2.5">{data}</p>
                                <p className="card-text fs-mdlg fw-600 text-textcolor">{post}</p>
                            </div>
                            <div className="inline-flex items-center">
                                <Image
                                    src="/img/icon-playstation-triangle.svg"
                                    alt="playstation"
                                    title="playstation"
                                    height="24"
                                    width="24"
                                    loading="lazy"
                                    className="img-fluid mr-2.5"
                                />
                                <p className="fw-600 text-primary mb-0 fs-md">Watch</p>

                                {/* <Link href={link} onClick={() => handleClick(testimonialvideo)} className="inline-flex items-center">
                                <Image
                                    src="/img/icon-playstation-triangle.svg"
                                    alt="playstation"
                                    title="playstation"
                                    height="24"
                                    width="24"
                                    loading="lazy"
                                    className="img-fluid mr-2.5"
                                />
                                <p className="fw-600 text-primary mb-0 fs-md">Watch</p>
                            </Link> */}
                            </div>
                        </div>
                        <div className="lg:w-3/6 md:w-3/6 w-full flex justify-center">
                            <Image
                                src={`${path}`}
                                width={width}
                                height={height}
                                alt="client"
                                className="img-fluid testimonial-client-img"
                            />
                        </div>
                    </div>
                </div>
            </Link>
        </div>
    );
};

export default TestimonialsCarouselItem;
